import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../Global/axios";
import nodeinstance from "../../nodeInstance";

const getVisscostandsecdeposite = createAsyncThunk(
  "/visacost",
  async (token) => {
    try {
      const response = await nodeinstance.get("/dashboard/visaSecurity", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
);

const visacostandsecdepositeSlice = createSlice({
  name: "visacost",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {}, // You can define your other regular reducers here if needed.
  extraReducers: (builder) => {
    builder
      .addCase(getVisscostandsecdeposite.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getVisscostandsecdeposite.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getVisscostandsecdeposite.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getVisscostandsecdeposite };
export default visacostandsecdepositeSlice.reducer;
